import React from 'react';
import { Modal, Badge } from 'react-bootstrap';
import './RecordDetailModal.css';

function RecordDetailModal({ show, onHide, record, fields, tableName, getFieldDisplayName, formatFieldValue }) {
  if (!record) return null;

  // Get visible fields (exclude very long text fields from detail view if needed)
  const visibleFields = fields.filter(f => !['Password', 'Secret', 'Token'].some(keyword => f.fieldName.includes(keyword)));

  // Check if a field is an image field
  const isImageField = (fieldName) => {
    const imageKeywords = ['Photo', 'Image', 'ProfilePhoto', 'ProfileImage', 'Avatar', 'Picture', 'URL'];
    return imageKeywords.some(keyword => fieldName.toLowerCase().includes(keyword.toLowerCase()));
  };

  return (
    <Modal show={show} onHide={onHide} size="lg" centered className="record-detail-modal">
      <Modal.Header closeButton>
        <Modal.Title>
          {tableName}
          <Badge bg="info" className="ms-2">Details</Badge>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="detail-container">
          {visibleFields.map(field => {
            const value = record[field.fieldName];
            const showImage = isImageField(field.fieldName) && value;

            return (
              <div key={field.fieldName} className={`detail-row ${showImage ? 'image-row' : ''}`}>
                <div className="detail-label">
                  {getFieldDisplayName(field.fieldName)}
                </div>
                <div className="detail-value">
                  {showImage ? (
                    <img 
                      src={value} 
                      alt={getFieldDisplayName(field.fieldName)}
                      className="detail-image"
                      onError={(e) => {
                        e.target.style.display = 'none';
                        e.target.nextElementSibling.style.display = 'block';
                      }}
                    />
                  ) : (
                    formatFieldValue(field.fieldName, value)
                  )}
                  {showImage && (
                    <span className="image-error" style={{ display: 'none' }}>
                      Image not found
                    </span>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default RecordDetailModal;
